import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ClientesRoutingModule } from "./clientes-routing.module";
import { ClientesComponent } from "./clientes.component";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { ClienteModule } from "../../../forms/clientes/cliente.module";
import { MaterialModule } from "../../../components/material/material.module";
import { VolverModule } from "../../../components/volver/volver.module";
import { TipoClienteModule } from "../../../forms/clientes/tipos-cliente/tipo-cliente.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        BotonToggleModule,
        MaterialModule,
        ClientesRoutingModule,
        ClienteModule,
        VolverModule,
        TipoClienteModule,
    ],
    declarations: [
        ClientesComponent
    ],
    providers: [
    ],
    entryComponents: [
    ]
})
export class ClientesModule { }